export const CMS_CREATIVE_NAMES = {
  BenefitsWidget: 'chewy-plus-value-prop-zone-3',
  HowItWorksInfoWidget: 'chewy-plus-value-prop-zone-5',
  FaqWidget: 'chewy-plus-landing-page-faq-zone-7',
  EnjoyWidget: 'chewy-plus-enjoy-zone-5',
  V2_30DayFreeTrialWidget: 'Member-Sign-Up-30DayTrial-1216',
} as const;

export const TRY_30_DAY_FREE_TRIAL_BUTTON_ZONE = 5;

export const ZONES_WITH_SIGN_UP_BUTTON = new Set([
  CMS_CREATIVE_NAMES.BenefitsWidget,
  CMS_CREATIVE_NAMES.EnjoyWidget,
  CMS_CREATIVE_NAMES.V2_30DayFreeTrialWidget,
]);
